import React, { Component } from 'react';
import Btn from '../../components/btn';

export default class Main extends Component {
	constructor(props) {
		super(props);
		this.state = {
			step: 0,
		};
	}
	
	render() {
		// let logo = '';
		// let mainBg = '';
		// if(window.innerWidth < 768){
		// 	logo = <img src='./logo-mobile.svg' alt='' />;
		// 	mainBg = <img src="./main-bg-mobile.svg" alt="" />;
		// } else {
		// 	logo = <img src='./logo.svg' alt='' />;
		// 	mainBg = <img src="./main-bg.svg" alt="" />;
		// }
		return (
			<div className='main'>
				<div className='container'>
					<div className='main__inner'>
						<a href='/' className='main__logo'>
							{/* {logo} */}
							<picture>
								{/* <source media="(max-width: 768px)" srcset="./logo.svg"/> */}
								<img src="./logo.svg" alt="" />
							</picture>
						</a>
						<h1 className='main__title'>Попробуй, визуализируй это</h1>
						<Btn className='main__btn' color={'black'} onClick={this.props.updatePage.bind(this, 1)}>НАЧАТЬ</Btn>
						<div className='main__desc'>
							Тест на грамотность датавизуализации
						</div>
						
					</div>
				</div>
				<div className="main__bg">
					{/* {mainBg} */}
					<picture>
						<source media="(max-width: 768px)" srcset="./main-bg-mobile.svg"/>
						<img src="./main-bg.svg" alt="" />
					</picture>
				</div>
			</div>
		);
	}
}
